import { CashierModel } from './cashier.model';

export class BranchOfficeModel {
  public id: number;
  public name: string;
  public address: string;
  public phone: string;
  public type: string;
  public cashiers: CashierModel[];

  constructor() {
    this.id = 0;
    this.name = '';
    this.address = '';
    this.phone = '';
    this.type = '';
  }

  public isPresent(): boolean {
    return this.id != 0;
  }

  public isMainOffice(): boolean {
    return this.type == 'P';
  }
}
